import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SelectCouponType from './SelectCouponType';
import SelectCategoryCollection from './SelectCategoryCollection/SelectCategoryCollection';
import SelectCustomCollection from './SelectCustomCollection/SelectCustomCollection';
import SelectDuration from './SelectDuration';
import SelectProducts from './SelectProducts/SelectProducts';

function Modal() {
    const [visible, setVisible] = useState(false);

    const activeModal = useSelector((state) => state.coupons.modal.activeModal);
    const displayModal = useSelector((state) => state.coupons.modal.displayModal);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'select-coupon-type' && <SelectCouponType />}

            {activeModal === 'select-category-collection' && <SelectCategoryCollection />}

            {activeModal === 'select-custom-collection' && <SelectCustomCollection />}
            
            {activeModal === 'select-product' && <SelectProducts />}

            {activeModal === 'select-duration' && <SelectDuration />}
        </div>
    );
}

export default Modal;
